export const ROUTES = {
  HOMEPAGE: '/',
  LOGIN: '/login',
  LOGIN_VERIFICATION_CODE: '/login/:userId/:verificationCode',
};
